export const USER_FIELDS = {
  firstName: 'firstName',
  lastName: 'lastName',
  street: 'street',
  city: 'city',
  state: 'state',
  zipCode: 'zip_code',
  dateOfBirth: 'date_of_birth',
  phone: 'phone',
  socialSecurityNumber: 'social_security_number',
  email: 'email',
  id: 'id',
  identity: 'identity',
  address: 'address',
  general: 'general',
  name: 'name',
  age: 'age',
  acceptTerms: 'accept_terms'
};

export const SILA_USER_ERROR_MESSAGES = {
  [USER_FIELDS.firstName]: 'Invalid name',
  [USER_FIELDS.lastName]: 'Invalid last name',
  [USER_FIELDS.address]: 'Address Not Matched, Address Not Verified',
  [USER_FIELDS.city]: 'Invalid city name',
  [USER_FIELDS.state]: 'Invalid state name',
  [USER_FIELDS.zipCode]: 'Invalid Zip code',
  [USER_FIELDS.dateOfBirth]: 'DOB Miskey, DOB Not Verified',
  [USER_FIELDS.phone]: 'Invalid phone number',
  [USER_FIELDS.socialSecurityNumber]: 'SSN Miskey, SSN Not Verified'
};

export const KYC_ERROR_MESSAGES = {
  [USER_FIELDS.name]: 'Name Mismatch, Name Not verified',
  [USER_FIELDS.firstName]: 'Name Mismatch, Name Not verified',
  [USER_FIELDS.address]: 'Address Not Matched, Address Not Verified',
  [USER_FIELDS.dateOfBirth]: 'DOB Miskey, DOB Not Verified',
  [USER_FIELDS.socialSecurityNumber]: 'SSN Miskey, SSN Not Verified',
  [USER_FIELDS.age]: 'Age Verification'
};
